import React, { useRef, useMemo, useCallback } from 'react';
import styled from 'styled-components/macro';

import useFlavorStore from '../../../../../common/store/useFlavorStore';
import Container from '../../Container';
import { getVh } from '../../utils';
import useParallax from '../../useParallax';
import useAnimation from './useAnimation';

const Fruit = styled.img`
  aspect-ratio: 269/221;
  width: 40vw;
  min-width: 250rem;
  max-width: 300rem;
  height: auto;

  transform: rotate(-45deg);
`;

const LimeUno = styled.img`
  aspect-ratio: 199/152;
  width: 150rem;
  height: auto;

  transform: rotate(10deg);
`;

const LimeDos = styled.img`
  aspect-ratio: 144/140;
  width: 120rem;
  height: auto;
`;

const Mango = () => {
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  const ref = {
    figure: {
      fruit: useRef<HTMLElement>(null),
      limeUno: useRef<HTMLElement>(null),
      limeDos: useRef<HTMLElement>(null)
    },
    img: {
      fruit: useRef<HTMLImageElement>(null),
      limeUno: useRef<HTMLImageElement>(null),
      limeDos: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    fruit: useMemo(() => getVh("flavor", 0.5), []),
    limeUno: useMemo(() => getVh("flavor", 0.35), []),
    limeDos: useMemo(() => getVh("flavor", 0.2), [])
  }

  useAnimation(flavor === "mango", [ref.figure.fruit, ref.figure.limeUno, ref.figure.limeDos])

  useParallax(ref.img.fruit, top.fruit, 50);
  useParallax(ref.img.limeUno, top.limeUno, 100);
  useParallax(ref.img.limeDos, top.limeDos, 100);

  return (
    <>
      <Container
        ref={ref.figure.fruit}
        top={top.fruit}
        style={{ left: "55vw" }}
      >
        <Fruit
          ref={ref.img.fruit}
          src="/static/images/fill/mango.png"
        />
      </Container>

      <Container
        ref={ref.figure.limeUno}
        top={top.limeUno}
        style={{ left: "80vw" }}
      >
        <LimeUno
          ref={ref.img.limeUno}
          src="/static/images/fill/lime/2.png"
        />
      </Container>

      <Container
        ref={ref.figure.limeDos}
        top={top.limeDos}
        style={{ left: "50vw" }}
      >
        <LimeDos
          ref={ref.img.limeDos}
          src="/static/images/fill/lime/3.png"
        />
      </Container>
    </>
  );
}

export default Mango;